import React from 'react';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
} from 'reactstrap';

const items = [
  {
    image: 'images/banner1.jpg',
    name: 'Game 1',
    description: 'Game 1 description',
  },
  {
    image: 'images/banner2.jpg',
    name: 'Game 2',
    description: 'Game 2 description',
  },
];

export default (props) => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [animating, setAnimating] = React.useState(false);

  const onNext = () => {
    if (!animating) {
      const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
      setActiveIndex(nextIndex);
    }
  };

  const onPrevious = () => {
    if (!animating) {
      const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
      setActiveIndex(nextIndex);
    }
  };

  const onSetIndex = (newIndex) => {
    if (!animating) {
      setActiveIndex(newIndex);
    }
  };

  return (
    <Carousel activeIndex={activeIndex} next={onNext} previous={onPrevious}>
      <CarouselIndicators
        items={items}
        activeIndex={activeIndex}
        onClickHandler={onSetIndex}
      />

      {items.map((element, index) => {
        return (
          <CarouselItem
            key={index}
            onExiting={() => setAnimating(true)}
            onExited={() => setAnimating(false)}
          >
            <img
              src={element.image}
              alt={element.name}
              style={{ width: '100%' }}
            />
          </CarouselItem>
        );
      })}

      <CarouselControl
        direction={'prev'}
        directionText={'Previous'}
        onClickHandler={onPrevious}
      />
      <CarouselControl
        direction={'next'}
        directionText={'Next'}
        onClickHandler={onNext}
      />
    </Carousel>
  );
};
